
import {
  TApiAsyncApiPathParams,
  TApiAsyncApiQueryParams,
  TEpDevPApiConsumerProductByIdInternalPathParams,
  TEpDevPApiConsumerProductByIdPathParams,
  TEpDevPApiConsumerProductByIdQueryParams,
} from './types';
import { 
  EpDevPUtils, 
  EpDevPAssetsApiRoutesFactory,
  EpDevPAssetsApiPathsFactory
} from '@solace-labs/backstage-plugin-ep-devp-common';

const ASYNC_APIS = 'asyncApis';

export class EpDevPConsumerProductsApiRoutesFactory extends EpDevPAssetsApiRoutesFactory {

  public static getSubRouteConsumerProductById = (): string => {
    return `/:${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdPathParams>('organizationId')}`
    + `/:${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdPathParams>('domainId')}`
    + `/:${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdPathParams>('eventApiProductId')}`;
  }

  public static getSubRouteConsumerProductByIdInternal = (): string => {
    return `/:${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdInternalPathParams>('organizationId')}`
    + `/:${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdInternalPathParams>('eventApiProductId')}`
  }

  public static getSubRouteAsyncApi = (): string => {
    return EpDevPConsumerProductsApiRoutesFactory.getSubRouteDomainById()
    + `/${ASYNC_APIS}`
    + `/:${EpDevPUtils.nameOf<TApiAsyncApiPathParams>('planId')}`
    + `/:${EpDevPUtils.nameOf<TApiAsyncApiPathParams>('eventApiId')}`;
  }
}

export class EpDevPConsumerProductsApiPathsFactory extends EpDevPAssetsApiPathsFactory {

  public static createConsumerProductByIdPath({ organizationId, domainId, eventApiProductId, versionString }: {
    organizationId: string;
    domainId: string;
    eventApiProductId: string;
    versionString?: string;
  }): string {
    const queryParams: string[] = [];
    if(versionString !== undefined) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdQueryParams>("version")}=${versionString}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${domainId}/${eventApiProductId}?${queryString}`;
  }

  public static createConsumerProductByIdInternalPath({ organizationId, eventApiProductId, versionString }: {
    organizationId: string;
    eventApiProductId: string;
    versionString?: string;
  }): string {
    const queryParams: string[] = [];
    if(versionString !== undefined) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPApiConsumerProductByIdQueryParams>("version")}=${versionString}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${eventApiProductId}?${queryString}`;
  }

  public static createAsyncApiPath({ 
    organizationId,
    domainId,
    eventApiProductId,
    eventApiId,
    planId, 
    format, 
    asyncApiVersion,
    fileNamePathForZip,
  }: {
    organizationId: string;
    domainId: string;
    eventApiProductId: string;
    eventApiId: string;
    planId: string;
    format: string;
    asyncApiVersion: string;
    fileNamePathForZip?: string;
  }): string {
    const queryParams: string[] = [];
    queryParams.push(`${EpDevPUtils.nameOf<TApiAsyncApiQueryParams>("format")}=${format}`);
    queryParams.push(`${EpDevPUtils.nameOf<TApiAsyncApiQueryParams>("asyncApiVersion")}=${asyncApiVersion}`);
    if(fileNamePathForZip) queryParams.push(`${EpDevPUtils.nameOf<TApiAsyncApiQueryParams>("fileNamePathForZip")}=${fileNamePathForZip}`);    
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${domainId}/${eventApiProductId}/${ASYNC_APIS}/${planId}/${eventApiId}?${queryString}`;
  }

}

